import { useQuery } from "react-query";
import { AdoSprint, fetchAdoSprints } from "../api/aiMetricsApi";
import { ADO_QUERY_KEYS } from "./adoQueryKeys";

const STALE_TIME = 5 * 60 * 1000;

export const useAdoSprints = () => {
  return useQuery<AdoSprint[], Error>({
    queryKey: [ADO_QUERY_KEYS.sprints],
    queryFn: fetchAdoSprints,
    staleTime: STALE_TIME,
  });
};
